import debug from 'debug';
import { Action } from 'redux';

import routes from '@configs/routes.json';
import { get } from '@services/method';

type ClinicalReportAction = 'GOT_CLINICAL_REPORT';

export type ClinicalReport = 'Disabled' | 'ReportAvailable';

export interface GetClinicalReportAction extends Action<ClinicalReportAction> {
  payload: ClinicalReport;
}

const log = debug('store:clinical-report');

export const getClinicalReport = () => {
  return (dispatch: (action: GetClinicalReportAction) => void) => {
    get(routes.api.reports.getState.replace(':type', 'CDxBatch'))
      .then((response) => response.json())
      .then((clinicalReport) =>
        dispatch({ type: 'GOT_CLINICAL_REPORT', payload: clinicalReport })
      )
      .catch((error) => {
        log(error);
      });
  };
};
